/* eslint-disable no-undef */
// userSaga.js
import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
// import { passportRequestError, passportRequestSuccess } from './Actions';
import { LIST_ONDEMAND_HEALTH_RECORD_REQUEST, ONDEMAND_HEALTH_RECORD_REQUEST, ONDEMAND_REQUEST } from './Constants';
import { ondemandHealthRecordRequestError, ondemandHealthRecordRequestSuccess, ondemandListHealthRecordRequestError, ondemandListHealthRecordRequestSuccess, ondemandRequestError, ondemandRequestSuccess } from './Actions';
import { Modal } from 'antd';
// import { Modal } from 'antd';


function* postOndemand(action) {

    try {

        let id = action.payload.docId;
        const consultationType = action.payload.consultType;
        const consultIn = action.payload.selectedResidence;

        const consultaionData = action.payload;

        let consultation;
        if (consultationType === 'walk') {
            if (consultIn === 'INTERNATIONAL') {
                consultation = 10;
            } else if (consultIn === 'NRI') {
                consultation = 12;
            } else {
                consultation = 2;
            }
        }

        if (consultationType === 'online') {
            if (consultIn === 'INTERNATIONAL') {
                consultation = 9;
            } else if (consultIn === 'NRI') {
                consultation = 11;
            } else {
                consultation = 4;
            }
        }

        const urll = `${process.env.REACT_APP_API_BASE_URL}/orgdoctors?doctorsId=${id}`;

        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            Authorization: sessionStorage.jwt,
            'Content-Type': 'application/json',
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };

        const response1 = yield call(axios.get, urll, { headers });

        if (response1.status === 200 || response1.status === 201) {
            
            var orgid = response1?.data?.data[0].organisationsId;
            var orgName = response1?.data?.data[0].organisation.name;


            const url2 = `${process.env.REACT_APP_API_BASE_URL}/requestappointments`;

            const data = {
                date: consultaionData.date,
                time: consultaionData.time,
                duration: consultaionData.duration,
                isApproved: 'null',
                patientsId: consultaionData.patientssId,
                doctorsId: id,
                consultationtypeId: consultation,
                organisationsId: orgid,
                parentId: localStorage.getItem('PARENT_PATIENT_ID'),
                createdByOrgId: 1,
                platform: 'QuikDr Webapp',
                consultingOrgId: consultaionData.microId,
                createdByOrgName: orgName,
                notes: consultaionData.notes,
            };

            const response2 = yield call(axios.post, url2, data, { headers });

            if (response2.status === 200 || response2.status === 201) {
                Modal.success({
                    title: 'Request sent successfully',
                    content: 'Coresponding hospital will get back to you soon...',
                });
                yield put(ondemandRequestSuccess(response2.data));
            } else {
                yield put(ondemandRequestError('An error occurred.'));
            }
        } else {
            yield put(ondemandRequestError('An error occurred.'));

        }


    } catch (error) {
        yield put(ondemandRequestError('An error occurred.'));
    }
}

function* healthRecordList() {
    try {    
        
        const url = `${process.env.REACT_APP_API_BASE_URL}/healthrectype`;
  
        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
  
        // // const data = {};  // Data you want to send with the POST request (can be empty for a simple POST)
  

        const response = yield call(axios.get, url,{ headers});

        // // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
            
            // Dispatch the success action with data and message      
            yield put(ondemandListHealthRecordRequestSuccess(response.data.data));
        } else {
            // Dispatch the failure action with the response message
            yield put(ondemandListHealthRecordRequestError('An error occurred.'));
        }

    } catch (error) {
        
        yield put(ondemandListHealthRecordRequestError('An error occurred.'));
        // throw error;
    // yield put(fetchUserFailure(error));
    }
}


function* healthRecordUpload (action) {
    try {    
        
        const patientId = sessionStorage.getItem('PATIENT_ID');
        const userId = sessionStorage.getItem('USER_ID');
        
        const formdata = new FormData();
        formdata.append('file',  action.payload.file);
        formdata.append('patientsid', patientId);
        formdata.append('healthrectype',  action.payload.selectValue);
        formdata.append('organisationsid', 1);
        formdata.append('usersid', userId);
        formdata.append('createdByOrgId', 1);
        
        const data = formdata;
        
        
        const url = `${process.env.REACT_APP_API_BASE_URL}/healthrecupload`;
  
        // // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
  
  
        const response = yield call(axios.post, url, data, { headers});

        if (response.status === 201) {
            Modal.success({
                title: 'Health Record Uploaded Successfully',
            });
            yield put(ondemandHealthRecordRequestSuccess('success'));
        } else if (response.status === 403) {
            Modal.warning({
                title: 'No file selected',
            });
            yield put(ondemandHealthRecordRequestError('An error occurred.'));
        }

    } catch (error) {        
        yield put(ondemandHealthRecordRequestError('An error occurred.'));
    }
}

// Watcher Saga
export function* watchFetchOndemand() {
    yield takeEvery(ONDEMAND_REQUEST, postOndemand);
    yield takeEvery(LIST_ONDEMAND_HEALTH_RECORD_REQUEST, healthRecordList);
    yield takeEvery(ONDEMAND_HEALTH_RECORD_REQUEST, healthRecordUpload);

}
